export default __webpack_public_path__ + "static/media/advance-payment-v2.db540e51.svg";